module.exports = __webpack_public_path__ + "static/media/icon_512@1x.4319a46c.png";